import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    icons: {
        cursor: "pointer",
        color: theme.palette.primary.main,
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.primary.main}`,
        "&:hover": {
            background: theme.palette.background.default,
        },
    },
}));
